const swiperIconText = new Swiper('.icont-slider__contents', {
  loop: true,
  slidesPerView: 1,
  spaceBetween: 10,
  pagination: {
    el: '.icont-pagination',
    clickable: true,
  },
  breakpoints: {
    580: {
      slidesPerView: 2,
    },
    980: {
      slidesPerView: 4,
      spaceBetween: 0,
    },
  }
});
